if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.addSwipeListener();
        this.controlBtns();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.addDotsNavigation();
        this.changeActiveDot();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        // activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      isMobileDevice() {
        const user_agent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(user_agent)) {
          return true;
        } else if (/iPad|iPhone|iPod/.test(user_agent) && !window.MSStream) {
          return true;
        }
        return false;
      }

      addDotsNavigation() {
        let nav_exists = this.querySelector('.product-media-modal__nav') ? true : false;
        if (nav_exists === false) {
          let items = this.querySelectorAll('.product-media-modal__item');
          if (items.length) {
            
            let content = this.querySelector('.product-media-modal__content'),
                nav = document.createElement('div');
            nav.classList.add('product-media-modal__nav');
            items.forEach((item) => {
              nav.innerHTML += `<div class="product-media-modal__nav__item"></div>`;
            });  
            content.appendChild(nav);

            let nav_items = this.querySelectorAll('.product-media-modal__nav__item');
            nav_items.forEach((nav_item, nav_item_index) => {
              nav_item.addEventListener('click', () => {
                items.forEach((item, item_index) => {
                  if (nav_item_index == item_index) {
                    item.classList.add('active');
                  } else {
                    item.classList.remove('active');
                  };
                });
                this.changeActiveDot();
              });
            });
          }
        }
      }

      changeActiveDot() {
        let modal_items = this.querySelectorAll('.product-media-modal__item'),
            modal_item_active_index = false,
            nav_items = this.querySelectorAll('.product-media-modal__nav__item');

        modal_items.forEach((item, index) => {
          if (item.classList.contains('active')) {
            modal_item_active_index = index;
          }
        }); 

        nav_items.forEach((nav_item, index)=> {
          if (index === modal_item_active_index) {
            nav_item.classList.add('active');
            let _video = modal_items[modal_item_active_index].querySelectorAll('video'),
                _video_btn = modal_items[modal_item_active_index].querySelector('.deferred-media__poster:not(.deferred-media__poster-button--play-model)');
            if (_video.length) {
              _video.forEach(_vid => {
                _vid.play();
              });
            } else if (_video_btn) {
              _video_btn.click();
            }
          } else {
            nav_item.classList.remove('active');
            let _video = modal_items[index].querySelectorAll('video');
            if (_video.length) {
              _video.forEach(_vid => {
                _vid.pause();
               
              });
            }
          }
        });
      }

      addSwipeListener() {
        let modal_content = this.querySelector('.product-media-modal__content');
        if (modal_content) {
          let startX = 0,
              startY = 0,
              distX = 0,
              distY = 0;

          modal_content.addEventListener('touchstart', (e) => {
            let touch = e.changedTouches[0];
            startX = touch.pageX;
            startY = touch.pageY;
          }, false);

          modal_content.addEventListener('touchmove', (e) => {
            e.preventDefault();
          }, false);

          modal_content.addEventListener('touchend', (e) => {
            let touch = e.changedTouches[0],
                direction = false;
            
            distX = touch.pageX - startX;
            distY = touch.pageY - startY;

            if (distX > 0) {
              direction = 'prev';
            } else {
              direction = 'next';
            }

            let product_zoom = null;

            let product_model = document.elementFromPoint(touch.pageX, touch.pageY).closest('product-model[loaded="true"]');
            if (document.elementFromPoint(touch.pageX, touch.pageY).classList.contains('image_zoom__box')) {
              product_zoom = document.elementFromPoint(touch.pageX, touch.pageY).parentElement.dataset.zoom;
            }
            
            if (product_model || product_zoom) {
              // nothing
            } else {
              this.swipeAction(direction, distX);
            }

            distX = 0;
            distY = 0;
          }, false);
        }
      }

      controlBtns() {
        const content = this.querySelector('.product-media-modal__content');
        const prevBtn = document.createElement('div');
        prevBtn.classList.add('product-media-modal__btn', 'product-media-modal__btn--prev');
        prevBtn.addEventListener('click', () => {
          this.swipeAction('prev', 100);
        });
        content.appendChild(prevBtn);
        const nextBtn = document.createElement('div');
        nextBtn.classList.add('product-media-modal__btn', 'product-media-modal__btn--next');
        nextBtn.addEventListener('click', () => {
          this.swipeAction('next', 100);
        });
        content.appendChild(nextBtn);
      }

      swipeAction(direction, distance) {
        let items = this.querySelectorAll('.product-media-modal__item'),
            current_item_index = false,
            max_item_index = false,
            prev_item_index = false,
            next_item_index = false,
            distance_abs = Math.abs(distance);
        
        if (items.length > 1 && distance_abs > 10) {
          max_item_index = items.length - 1;

          items.forEach((item, index) => {
            let _video = item.querySelector('video');
            if (_video) {
              _video.pause();
              
            }

            if (item.classList.contains('active')) {
              current_item_index = index;
              item.classList.remove('active');
            }
          });

          if (current_item_index > 0) {
            prev_item_index = current_item_index - 1;
          } else {
            prev_item_index = max_item_index;
          }

          if (current_item_index < max_item_index) {
            next_item_index = current_item_index + 1;
          } else {
            next_item_index = 0;
          }

          if (direction == 'prev' && prev_item_index !== false) {
            items[prev_item_index].classList.add('active');
          }

          if (direction == 'next' && next_item_index !== false) {
            items[next_item_index].classList.add('active');
          }
        }

        this.changeActiveDot();
      }

    }
  );
}
